import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import React, { useEffect, useState, useCallback } from 'react'
import { store } from 'reduxStore'
import { useSelector } from 'react-redux'
import api from 'api';
import eventBus from "../../utils/eventBus";

import NavWidget from "./NavWidget.js";
import NavCard from "./NavCard.js";
import NavDisclosure from "./NavDisclosure.js";
import NavBusinessForm from "./NavBusinessForm.js";
import NavSubLogo from './nav-sub-logo.svg'
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots';
import ZendeskLink from 'components/Common/ZendeskLink';

var sx = {
    center: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
    }
}

const dialogStyles = {
    width: "43%",
    height: "75%",
    borderRadius: "25px",
    marginTop: 10
}

export default function NavMain() {

    const dashboardInfo = useSelector(state => state.apiResponseReducers.dashboardInfo);
    const userData = store.getState().userReducer.user
    const [states, setStates] = useState([]);
    const [selectedBusiness, setSelectedBusiness] = useState(null);
    const [navToken, setNavToken] = useState(null);
    const [openFormDialog, setOpenFormDialog] = useState(false);
    const [showDisclosure, setShowDisclosure] = useState(false);

    async function getAuthToken() {
        try {
            const res = await api.getNavAuthToken();
            setNavToken(res.authToken);
        } catch (e) {
            setNavToken(false)
        }
    }

    const getSelectedBusiness = useCallback(async function () {
        const profileRes = await api.getBusinessProfile()
        const currentProfile = profileRes?.details?.filter(b => Number(b?.bpId) === dashboardInfo?.user_info?.currentProfileId)?.[0] || {};
        const bpStateCode = currentProfile?.bpState || ''
        const bpPhone = currentProfile?.bpContactPhone || ''
        const maskPhone = bpPhone ? bpPhone.slice(0, 3) + -+bpPhone.slice(3, 6) + -+bpPhone.slice(6, 10) : ''

        const selectedBusiness = {
            profileId: currentProfile.bpId,
            firstName: userData?.firstName || currentProfile.bpFirstName || '',
            lastName: userData?.lastName || currentProfile.bpLastName || '',
            bizName: currentProfile.bpBizName || '',
            bizPhone: maskPhone,
            bizState: bpStateCode || '',
            bizZip: currentProfile.bpZip || ''
        }

        return selectedBusiness;
    }, [dashboardInfo, userData])


    useEffect(() => {
        (async function () {
            const res = await api.getStateName('')
            const data = res.details.map(x => { return { id: x.state_code, label: x.state_display_name } });
            setStates(data);

            let business = await getSelectedBusiness();
            setSelectedBusiness(business);


            await getAuthToken();
        })()
    }, [getSelectedBusiness])


    const onNavClick = useCallback(function () {
        if (navToken === false) {
            setOpenFormDialog(true);
        }

        else if (typeof navToken === "string") {
            eventBus.emit('openNav')
        }
    }, [navToken])

    useEffect(() => {
        eventBus.on('navClick', onNavClick);
        return function () {
            eventBus.off('navClick', onNavClick);
        }
    }, [onNavClick])




    async function onNavFormSubmit(values) {
        const reqBody = {
            ...selectedBusiness,
            ...values
        }

        await api.createNavUser(reqBody);
        await getAuthToken();
        setTimeout(() => {
            eventBus.emit('navClick');
        }, 1000)
    }

    return (
        <Box sx={sx.center}>
            {navToken === null && <ThreeDotsLoadingSpinner width="60px" />}

            {navToken === false &&
                <div>
                    <NavCard
                        imageURL={NavSubLogo}
                        title="Need Help Finding Financing"
                        body="Check Nav for business lines of credit, loans, credit cards & more."
                        buttonText="See Your Options"
                        onClick={onNavClick}
                        onDisclosureClick={() => setShowDisclosure(true)}></NavCard>
                    <Dialog open={openFormDialog} PaperProps={{ sx: dialogStyles }} maxWidth={"md"}>
                        <DialogTitle textAlign={"center"}>Submit Information to Nav
                            <IconButton
                                aria-label="close"
                                onClick={() => { setOpenFormDialog(false) }}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton></DialogTitle>
                        <DialogContent sx={{ height: "800px" }}>
                            <NavBusinessForm business={selectedBusiness} states={states} onSubmit={onNavFormSubmit} />
                            <Box marginTop="18px" marginBottom="15px">
                                <Divider sx={{ width: '435px', color: "#0a78cd", marginLeft: 6 }} />
                            </Box>
                            <ZendeskLink />
                        </DialogContent>
                    </Dialog>
                </div>
            }

            {typeof navToken === "string" &&
                <NavWidget token={navToken} onDisclosureClick={() => setShowDisclosure(true)} />
            }

            <NavDisclosure open={showDisclosure} onClose={() => setShowDisclosure(false)} />
        </Box>
    )
}